<template>
  <div class="container">
    <div class="questions">
      <!-- Si pas de valeur dans les questions Première question -->
      <div class="question1">
        <p>
          La patiente a-t-elle des contre-indications absolues aux
          ostro-progestatifs ?
        </p>
        <ul class="subtitle">
          <li>
            Des antécédents personnels ou un événement actuel de thrombose, par
            exemple une thrombose veineuse profonde, une embolie pulmonaire, un
            infarctus du myocarde, un accident vasculaire cérébral, un accident
            ischémique transitoire, un angor ?
          </li>
          <li>Un trouble personnel connu de la coagulation ?</li>
          <li>Des antécédents de migraine avec aura ?</li>
          <li>Un diabète avec complications vasculaires ?</li>
          <li>
            Une pression artérielle très élevée, par exemple une pression
            systolique ≥ 160 mmHg ou une pression diastolique ≥ 100 mmHg ?
          </li>
          <li>Une hyperlipidémie importante ?</li>
          <li>
            Une intervention chirurgicale majeure ou une période
            d'immobilisation prolongée est-elle prévue ? Si tel est le cas,
            suspendre l'utilisation et conseiller une méthode de contraception
            non hormonale au moins pendant les 4 semaines précédant
            l’intervention ou l’immobilisation et les 2 semaines suivant le
            retour à une mobilité complète.
          </li>
        </ul>
        <div class="buttons">
          <button
            :class="{
              btn: !getClickedYesQuest1,
              'btn-blue': getClickedYesQuest1,
            }"
            @click="
              sendYesQuestion1('YES');
              scrollToElement(1);
            "
          >
            OUI
          </button>
          <button
            :class="{
              btn: !getClickedNoQuest1,
              'btn-blue': getClickedNoQuest1,
            }"
            @click="
              sendNoQuestion1('NO');
              scrollToElement(1);
            "
          >
            NON
          </button>
        </div>
      </div>
      <!-- Si valeur dans la question 1 mais que c'est pas la question 3 appel de la question 2 -->
      <div v-if="getMyQuestions.question1.value" class="question2">
        <p>{{ getMyQuestions.question2.question }}</p>
        <span v-if="getMyQuestions.question2.span">{{
          getMyQuestions.question2.span
        }}</span>
        <div class="buttons">
          <button
            :class="{
              btn: !getClickedYesQuest2,
              'btn-blue': getClickedYesQuest2,
            }"
            @click="
              sendYesQuestion2('YES');
              scrollToElement(2);
            "
          >
            OUI
          </button>
          <button
            :class="{
              btn: !getClickedNoQuest2,
              'btn-blue': getClickedNoQuest2,
            }"
            @click="
              sendNoQuestion2('NO');
              scrollToElement(2);
            "
          >
            NON
          </button>
        </div>
      </div>
      <div v-if="getMyQuestions.question3.question" class="question2">
        <p>{{ getMyQuestions.question3.question }}</p>
        <span v-if="getMyQuestions.question3.span">{{
          getMyQuestions.question3.span
        }}</span>
        <div class="buttons">
          <button
            :class="{
              btn: !getClickedYesQuest3,
              'btn-blue': getClickedYesQuest3,
            }"
            @click="
              sendYesQuestion3('YES');
              scrollToElement(3);
            "
          >
            OUI
          </button>
          <button
            :class="{
              btn: !getClickedNoQuest3,
              'btn-blue': getClickedNoQuest3,
            }"
            @click="
              sendNoQuestion3('NO');
              scrollToElement(3);
            "
          >
            NON
          </button>
        </div>
      </div>
      <div v-if="getMyQuestions.question4.question" class="question2">
        <p>{{ getMyQuestions.question4.question }}</p>
        <span v-if="getMyQuestions.question4.span">{{
          getMyQuestions.question4.span
        }}</span>
        <div class="buttons">
          <button
            :class="{
              btn: !getClickedYesQuest4,
              'btn-blue': getClickedYesQuest4,
            }"
            @click="
              sendYesQuestion4('YES');
              scrollToElement(4);
            "
          >
            OUI
          </button>
          <button
            :class="{
              btn: !getClickedNoQuest4,
              'btn-blue': getClickedNoQuest4,
            }"
            @click="
              sendNoQuestion4('NO');
              scrollToElement(4);
            "
          >
            NON
          </button>
        </div>
      </div>
      <div v-if="getMyQuestions.question5.question" class="question2">
        <p>{{ getMyQuestions.question5.question }}</p>
        <span v-if="getMyQuestions.question5.span">{{
          getMyQuestions.question5.span
        }}</span>
        <div class="buttons">
          <button
            :class="{
              btn: !getClickedYesQuest5,
              'btn-blue': getClickedYesQuest5,
            }"
            @click="
              sendYesQuestion5('YES');
              scrollToElement(5);
            "
          >
            OUI
          </button>
          <button
            :class="{
              btn: !getClickedNoQuest5,
              'btn-blue': getClickedNoQuest5,
            }"
            @click="
              sendNoQuestion5('NO');
              scrollToElement(5);
            "
          >
            NON
          </button>
        </div>
      </div>
      <div v-if="getMyQuestions.question6.question" class="question2">
        <p>{{ getMyQuestions.question6.question }}</p>
        <span v-if="getMyQuestions.question6.span">{{
          getMyQuestions.question6.span
        }}</span>
        <div class="buttons">
          <button
            :class="{
              btn: !getClickedYesQuest6,
              'btn-blue': getClickedYesQuest6,
            }"
            @click="
              sendYesQuestion6('YES');
              scrollToElement(6);
            "
          >
            OUI
          </button>
          <button
            :class="{
              btn: !getClickedNoQuest6,
              'btn-blue': getClickedNoQuest6,
            }"
            @click="
              sendNoQuestion6('NO');
              scrollToElement(6);
            "
          >
            NON
          </button>
        </div>
      </div>
      <div v-if="getMyQuestions.question7.question" class="question2">
        <p>{{ getMyQuestions.question7.question }}</p>
        <span v-if="getMyQuestions.question7.span">{{
          getMyQuestions.question7.span
        }}</span>
        <div class="buttons">
          <button
            :class="{
              btn: !getClickedYesQuest7,
              'btn-blue': getClickedYesQuest7,
            }"
            @click="
              sendYesQuestion7('YES');
              scrollToElement(7);
            "
          >
            OUI
          </button>
          <button
            :class="{
              btn: !getClickedNoQuest7,
              'btn-blue': getClickedNoQuest7,
            }"
            @click="
              sendNoQuestion7('NO');
              scrollToElement(7);
            "
          >
            NON
          </button>
        </div>
      </div>
      <div v-if="getMyQuestions.question8.question" class="question2">
        <p>{{ getMyQuestions.question8.question }}</p>
        <span v-if="getMyQuestions.question8.span">{{
          getMyQuestions.question8.span
        }}</span>
        <div class="buttons">
          <button
            :class="{
              btn: !getClickedYesQuest8,
              'btn-blue': getClickedYesQuest8,
            }"
            @click="
              sendYesQuestion8('YES');
              scrollToElement(8);
            "
          >
            OUI
          </button>
          <button
            :class="{
              btn: !getClickedNoQuest8,
              'btn-blue': getClickedNoQuest8,
            }"
            @click="
              sendNoQuestion8('NO');
              scrollToElement(8);
            "
          >
            NON
          </button>
        </div>
      </div>
    </div>
    <!-- Affichage du resultat -->
    <div v-if="getResult && getResult !== 'DIU cuivre'" class="result">
      <hr class="line" />
      <ul>
        <li>{{ getResult.split(", ")[0] }}</li>
        <li>{{ getResult.split(", ")[1] }}</li>
        <li>{{ getResult.split(", ")[2] }}</li>
        <li>{{ getResult.split(", ")[3] }}</li>
      </ul>
    </div>
    <div v-if="getResult && getResult === 'DIU cuivre'" class="result">
      <hr class="line" />
      <p>{{ getResult.split(", ")[0] }}</p>
    </div>
    <div v-else></div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      clicked: false,
    };
  },
  mounted() {
    // this.scrollToElement();
    this.arrowFunction();
  },
  computed: {
    ...mapGetters("Algo1Module", [
      "getMyQuestions",
      "getResult",
      "getClickedYesQuest1",
      "getClickedYesQuest2",
      "getClickedYesQuest3",
      "getClickedYesQuest4",
      "getClickedYesQuest5",
      "getClickedYesQuest6",
      "getClickedYesQuest7",
      "getClickedYesQuest8",
      "getClickedNoQuest1",
      "getClickedNoQuest2",
      "getClickedNoQuest3",
      "getClickedNoQuest4",
      "getClickedNoQuest5",
      "getClickedNoQuest6",
      "getClickedNoQuest7",
      "getClickedNoQuest8",
    ]),
  },
  methods: {
    ...mapActions("Algo1Module", [
      "sendYesQuestion1",
      "sendNoQuestion1",
      "sendYesQuestion2",
      "sendNoQuestion2",
      "sendYesQuestion3",
      "sendNoQuestion3",
      "sendYesQuestion4",
      "sendNoQuestion4",
      "sendYesQuestion5",
      "sendNoQuestion5",
      "sendYesQuestion6",
      "sendNoQuestion6",
      "sendYesQuestion7",
      "sendNoQuestion7",
      "sendYesQuestion8",
      "sendNoQuestion8",
      "arrowFunction",
    ]),
    scrollToElement(val) {
      setTimeout(function () {
        const el = document.getElementsByClassName("buttons")[val];
        const result = document.getElementsByClassName("result")[0];
        if (el && !result) {
          // Use el.scrollIntoView() to instantly scroll to the element
          el.scrollIntoView({ behavior: "smooth", block: "end" });
        } else result.scrollIntoView({ behavior: "smooth", block: "end" });
      }, 150);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/scss/variables/colors.scss";
@import "@/assets/styles/scss/variables/mixin.scss";
.container {
  width: 90%;
  padding: 0 0 0 18px;
  margin-top: 37px;
  .title {
    text-align: left;
    width: 202px;
    h2 {
      font-weight: 500;
      font-size: 29px !important;
      color: $primary;
      font: normal;
      line-height: 35px;
    }
  }
  .questions {
    margin-top: 35px;
    margin-bottom: 20px;
    p {
      font-size: 19px;
      color: $text-color-aigm;
      span {
        font-size: 14px;
      }
    }
    ul.subtitle {
      color: $text-color-aigm;
      font-size: 14px;
      margin-top: 10px;
      list-style-type: square;
      padding-left: 20px;
    }
    .buttons {
      margin-top: 50px;
      display: flex;
      justify-content: space-around;
      .btn {
        position: relative;
        width: 40%;
        text-align: center;
        margin: 0 auto;
        padding: 16px !important;
        @include button($backround-grey-aigm, $text-color-aigm);
      }
    }
  }
  .question2 {
    margin-top: 25px;
    margin-bottom: 30px;
    span {
      font-size: 14px;
      color: $text-color-aigm;
    }
  }
  .result {
    margin-top: 35px;
    margin-bottom: 30px;
    ul {
      list-style: none;
      li {
        color: $primary;
        font-weight: 600;
        font-size: 21px;
      }
      li::before {
        content: "• ";
        color: $primary; /* or whatever color you prefer */
      }
    }
    hr {
      border-top: 3px solid $primary;
    }
    p {
      font-size: 21px;
      color: $primary;
      font-weight: 600;
    }
  }
  .btn-blue {
    position: relative;
    width: 40%;
    text-align: center;
    margin: 0 auto;
    padding: 16px !important;
    @include button($primary, $white-aigm);
  }
}
</style>
